module.exports = __webpack_public_path__ + "img/videopokerwin.11915eb8.png";